export const UPDATE_UI_TEXT = 'UPDATE_UI_TEXT';
export const RESET_UI = 'RESET_UI';
export const SET_LOCALE = 'SET_LOCALE';
export const SET_CONNECT_NOTIFICATION_ALLOWED = 'SET_CONNECT_NOTIFICATION_ALLOWED';
export const SET_IS_AT_BOTTOM = 'SET_IS_AT_BOTTOM';
